import { dispatch } from '../dispatch'
import { FatalDecoratorLimitSetterError } from '../errors'
import { ObserveSetEvent } from '../event'
import { action } from '../signal'
import { undispatch, undispatchDepth } from '../undispatch'

import type { Annotation, Reactive } from '../types'

function createObserveDescriptor(
  proto: any,
  key: string,
  descriptor: PropertyDescriptor
): PropertyDescriptor {
  return {
    configurable: false,
    enumerable: true,
    ...descriptor,
    set(this: Reactive, value) {
      let event
      let setKey = key
      if (descriptor.get?.call(this) === value) return
      if (undispatchDepth === 0) {
        event = dispatch(new ObserveSetEvent(this, setKey, value))
        setKey = event.source.key
        value = event.source.value
      }
      /**
       * 这里的 action 和 undispatch 的顺序不能改，非常重要
       * descriptor.set 里的行为会触发 reaction 的 subscriber
       * subscriber 里如果也存在响应式赋值的话，也会被 undispatch 掉
       * 所以要用一个 action 把 subscriber 推到 undispatch 之后执行
       */
      action(() => {
        undispatch(() => {
          descriptor.set?.call(this, value)
        })
      })
    }
  }
}

/**
 * 这是一个非常特殊的装饰器，只能装饰到 setter 上，效果是：
 * 1. 自动给 setter 包装 action
 * 2. 屏蔽 setter 内部所有的 dispatch
 * 3. setter 被调用的时候会发出 dispatch value
 */
export const observe: Annotation = (value) => value

observe._name = 'observe'

observe._tsDecorator = (proto, key, descriptor) => {
  if (descriptor?.set === undefined) {
    throw new FatalDecoratorLimitSetterError(observe._name, key)
  }
  return createObserveDescriptor(proto, key, descriptor)
}
